
import React, { useState } from 'react';
import './App.css';

import ChatInterfaceFinal from './components/ChatInterfaceFinal';

function App() {
  

  return (
    <div className="recorder-container">
      {/* <UsingClude /> */}
      <ChatInterfaceFinal />
    </div>
  );
}

export default App;

// have a JSON IS COMPLETLY FILLLED WITH THE VALUES required to create a new facility
